import { createContext, ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useUserContext } from './user.context';

type SsoContextType = object;

const SsoContext = createContext({} as SsoContextType);

function SsoProvider({ children }: { children: ReactNode }) {
  const [queryParam] = useSearchParams();
  const openidToken = queryParam.get('openidToken');
  const { ssoAuth } = useUserContext();

  useEffect(() => {
    if (openidToken) {
      ssoAuth(openidToken);
    }
  }
  , []);

  return (

    <SsoContext.Provider value={{}}>
      {children}
    </SsoContext.Provider>
  );
}

SsoProvider.displayName = 'SsoProvider';

export { SsoProvider };

